import React, { useState } from "react";
import { Accordion, Form, FormLabel } from "react-bootstrap";

function SubSection3({
  slotBookingData,
  setSlotBookingData,
  validOrderCount,
  monthsIntoTreatment
}) {
  const handleCheckboxData = [
    "hairShedding",
    "explainedScience",
    "uploadScalpPic",
    "probingDone",
    "medicalEscalation",
    "scienceBehindWorking",
    "hairFallTakingPlace",
    "noResultInHairGrowth",
    "explainedScienceRegrowth",
    "explainedPostives",
    "explainedScienceBehaindWorking",
    "probeRegularity",
    "medicalEscalationProblem",
    "dandruffRelated",
    "gutCondition",
    "cxToStop",
    "reiteratedMonthlyGoals",
    "newSupplementAdded",
    "sleepOrStress",
  ];

  //   hairShedding: false,
  //   explainedScience: false,
  //   uploadScalpPic: false,
  //   probingDone: false,
  //   medicalEscalation: false,
  //   scienceBehindWorking: false,
  //   hairFallTakingPlace: false,
  //   noResultInHairGrowth: false,
  //   explainedScienceRegrowth: false,
  //   explainedPostives: false,
  //   explainedScienceBehaindWorking: false,
  //   probeRegularity: false,
  //   scabiesMonth: null,
  //   medicalEscalationProblem: false,
  //   dandruffRelated: false,
  //   dandruffRelatedStatus: null,
  //   gutCondition: false,
  //   cxToStop: false,
  //   gutConditionStatus: null,
  //   reiteratedMonthlyGoals: false,
  //   regularUsage: null,
  //   newSupplementAdded: false,
  //   explanation: "",
  //   sleepOrStress: false,
  //   sleepOrStressStatus: null,
  // });

  // Function to handle state change
  const handleCheckboxChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if (handleCheckboxData.includes(name)) {
      const checkedValue = event.target.checked;
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: checkedValue,
      }));
    } else {
      setSlotBookingData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  return (
    <>
      <Accordion>
        <Accordion.Item eventKey="2">
          <Accordion.Header className="border-bottom">
            Results (No results/Unhappy with results)
          </Accordion.Header>
          <Accordion.Body>
            <Form.Check
              type="checkbox"
              label="Excessive hair shedding (only if any of the last 3 kits contain minox / recap)"
              checked={slotBookingData?.hairShedding}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="hairShedding"
              name="hairShedding"
            />
            {slotBookingData?.hairShedding && (
              <>
                <Form.Check
                  type="checkbox"
                  label="Informed the science behind hair shedding, & how it's a positive sign to notice the following"
                  checked={slotBookingData?.explainedScience}
                  onChange={handleCheckboxChange}
                  className="mb-2"
                  id="explainedScience"
                  name="explainedScience"
                />
                <Form.Check
                  type="checkbox"
                  label="Recent Scalp Pic check & importance of uploading scalp pic"
                  checked={slotBookingData?.uploadScalpPic}
                  onChange={handleCheckboxChange}
                  className="mb-2"
                  id="uploadScalpPic"
                  name="uploadScalpPic"
                />
              </>
            )}
            <hr />
            <Form.Check
              type="checkbox"
              label="No result in hair fall (Minox + recap in the kit since)"
              checked={slotBookingData?.probingDone}
              onChange={handleCheckboxChange}
              className="mb-2"
              id="probingDone"
              name="probingDone"
            />
            {slotBookingData?.probingDone && (
              <div className="border-top">
                {validOrderCount !== 3 ? (
                  <Form.Check
                    type="checkbox"
                    label="Explained the science behind the working of Minox/Recap - reiterate they are in the hair shedding phase"
                    className="ml-4"
                    checked={slotBookingData?.scienceBehindWorking}
                    onChange={handleCheckboxChange}
                    id="scienceBehindWorking"
                    name="scienceBehindWorking"
                  />
                ) : (
                  <>
                    <Form.Check
                      type="checkbox"
                      label="Probing done on understanding how much hair fall is taking place/how have they been using the application (regularity)/have they had any drastic changes with lifestyle OR diet"
                      className="ml-4"
                      checked={slotBookingData?.hairFallTakingPlace}
                      onChange={handleCheckboxChange}
                      id="hairFallTakingPlace"
                      name="hairFallTakingPlace"
                    />
                    <Form.Check
                      type="checkbox"
                      label="Medical escalation - if all of the above is not a problem"
                      className="ml-4"
                      checked={slotBookingData?.medicalEscalation}
                      onChange={handleCheckboxChange}
                      id="medicalEscalation"
                      name="medicalEscalation"
                    />
                  </>
                )}
              </div>
            )}
            <hr />
            <Form.Check
              type="checkbox"
              label="No result in hair regrowth"
              className="mb-2"
              id="noResultInHairGrowth"
              checked={slotBookingData?.noResultInHairGrowth}
              onChange={handleCheckboxChange}
              name="noResultInHairGrowth"
            />
            {slotBookingData?.noResultInHairGrowth &&
              (validOrderCount === 1 || validOrderCount === 2) && (
                <Form.Check
                  type="checkbox"
                  label="Explained the science behind the working of Traya products and reiterate on expectation setting + monthly goal"
                  className="mb-2"
                  id="explainedScienceRegrowth"
                  checked={slotBookingData?.explainedScienceRegrowth}
                  onChange={handleCheckboxChange}
                  name="explainedScienceRegrowth"
                />
              )}
            {slotBookingData?.noResultInHairGrowth &&
              (validOrderCount === 3 || validOrderCount === 4) && (
                <>
                  <Form.Check
                    type="checkbox"
                    label="Explained positive that has happened in M1 and M2 basis monthly goals"
                    className="mb-2"
                    id="explainedPostives"
                    name="explainedPostives"
                    checked={slotBookingData?.explainedPostives}
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Explained the science behind the working of Traya products and reiterate on expectation setting + monthly goal"
                    className="mb-2"
                    id="explainedScienceBehaindWorking"
                    name="explainedScienceBehaindWorking"
                    checked={slotBookingData?.explainedScienceBehaindWorking}
                    onChange={handleCheckboxChange}
                  />
                </>
              )}
            {slotBookingData?.noResultInHairGrowth &&
              validOrderCount >= 5 && (
                <>
                  <Form.Check
                    type="checkbox"
                    label="Probing done on understanding how much hair fall is taking place/how have they been using the application (regularity)/ have they had any drastic changes with lifestyle OR diet"
                    className="mb-2"
                    id="probeRegularity"
                    name="probeRegularity"
                    checked={slotBookingData?.probeRegularity}
                    onChange={handleCheckboxChange}
                  />
                  <div className="d-flex flex-row gap-3 mb-n2">
                    <Form.Label className="text-primary">
                      Check month on month scabies uploaded (Y/N)
                    </Form.Label>
                    <Form.Check
                      inline
                      type="radio"
                      id="expectYes"
                      label="Yes"
                      value="Yes"
                      checked={
                        slotBookingData?.scabiesMonth == "Yes" ? true : false
                      }
                      required
                      name="scabiesMonth"
                      onChange={handleCheckboxChange}
                    />
                    <Form.Check
                      inline
                      type="radio"
                      id="expectNo"
                      label="No"
                      value="No"
                      checked={
                        slotBookingData?.scabiesMonth == "No" ? true : false
                      }
                      required
                      name="scabiesMonth"
                      onChange={handleCheckboxChange}
                    />
                  </div>
                  <Form.Check
                    type="checkbox"
                    label="Medical escalation raised if nothing in above is a problem"
                    className="mb-2"
                    id="medicalEscalationProblem"
                    name="medicalEscalationProblem"
                    checked={slotBookingData?.medicalEscalationProblem}
                    onChange={handleCheckboxChange}
                  />
                </>
              )}
            <hr />
            <Form.Check
              type="checkbox"
              label="Dandruff related"
              className="mb-2"
              id="dandruffRelated"
              name="dandruffRelated"
              checked={slotBookingData?.dandruffRelated}
              onChange={handleCheckboxChange}
            />
            {slotBookingData?.dandruffRelated && validOrderCount === 1 && (
              <>
                <div className="d-flex flex-row gap-3 mb-n2">
                  <Form.Check
                    inline
                    type="radio"
                    id="improved"
                    label="Improved"
                    value="improved"
                    checked={
                      slotBookingData?.dandruffRelatedStatus == "improved"
                        ? true
                        : false
                    }
                    required
                    name="dandruffRelatedStatus"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="notImproved"
                    label="Not Improved"
                    value="notImproved"
                    checked={
                      slotBookingData?.dandruffRelatedStatus == "notImproved"
                        ? true
                        : false
                    }
                    required
                    name="dandruffRelatedStatus"
                    onChange={handleCheckboxChange}
                  />
                </div>
                {slotBookingData?.dandruffRelatedStatus === "improved" && (
                  <ul style={{ listStyleType: "disc", marginLeft: "4px" }}>
                    <li className="text-primary">Pitched for o2 serums</li>
                  </ul>
                )}
                {slotBookingData?.dandruffRelatedStatus === "notImproved" && (
                  <ul style={{ listStyleType: "disc", marginLeft: "4px" }}>
                    <li className="text-primary">
                      Probed on regularity of usage
                    </li>
                    <li className="text-primary">
                      Added keto to o2 kit and did expectation setting for 1
                      more month of dandruff
                    </li>
                  </ul>
                )}
              </>
            )}
            {slotBookingData?.dandruffRelated && validOrderCount === 2 && (
              <>
                <div className="d-flex flex-row gap-3 mb-n2">
                  <Form.Check
                    inline
                    type="radio"
                    id="improved"
                    label="Improved"
                    value="improved"
                    checked={
                      slotBookingData?.dandruffRelatedStatus == "improved"
                        ? true
                        : false
                    }
                    required
                    name="dandruffRelatedStatus"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="notImproved"
                    label="Not Improved"
                    value="notImproved"
                    checked={
                      slotBookingData?.dandruffRelatedStatus == "notImproved"
                        ? true
                        : false
                    }
                    required
                    name="dandruffRelatedStatus"
                    onChange={handleCheckboxChange}
                  />
                </div>
                {slotBookingData?.dandruffRelatedStatus === "improved" && (
                  <ul style={{ listStyleType: "disc", marginLeft: "4px" }}>
                    <li className="text-primary">
                      Pitched for serums o3 onwards
                    </li>
                  </ul>
                )}
                {slotBookingData?.dandruffRelatedStatus === "notImproved" && (
                  <ul style={{ listStyleType: "disc", marginLeft: "4px" }}>
                    <li className="text-primary">
                      Probed on regularity of usage
                    </li>
                    <li className="text-primary">Medical escalation</li>
                  </ul>
                )}
              </>
            )}
            <hr />
            <Form.Check
              type="checkbox"
              label="Gut condition (if applicable)"
              className="mb-2"
              id="gutCondition"
              name="gutCondition"
              checked={slotBookingData?.gutCondition}
              onChange={handleCheckboxChange}
            />
            {slotBookingData?.gutCondition && (
              <>
                <div className="d-flex flex-row gap-3 mb-n2">
                  <Form.Check
                    inline
                    type="radio"
                    id="improved"
                    label="Improved"
                    value="improved"
                    checked={
                      slotBookingData?.gutConditionStatus == "improved"
                        ? true
                        : false
                    }
                    required
                    name="gutConditionStatus"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="notImproved"
                    label="Not Improved"
                    value="notImproved"
                    checked={
                      slotBookingData?.gutConditionStatus == "notImproved"
                        ? true
                        : false
                    }
                    required
                    name="gutConditionStatus"
                    onChange={handleCheckboxChange}
                  />
                </div>
                {slotBookingData?.gutConditionStatus === "improved" && (
                  <>
                    <p className="text-primary">
                      Emphasised on this being a small win and continue as per
                      product timeline
                    </p>
                    {monthsIntoTreatment >= 3 && (
                      <Form.Check
                        type="checkbox"
                        label="Explained the cx to stop"
                        className="mb-2"
                        id="cxToStop"
                        name="cxToStop"
                        checked={slotBookingData?.cxToStop}
                        onChange={handleCheckboxChange}
                      />
                    )}
                  </>
                )}
                {slotBookingData?.gutConditionStatus === "notImproved" && (
                  <p className="text-primary">
                    Recommended change (Gut shuddhi 0-0-2 / Consti clear)
                  </p>
                )}
              </>
            )}
            <hr />
            <Form.Check
              type="checkbox"
              label="Sleep/Stress (if applicable)"
              className="mb-2"
              id="sleepOrStress"
              name="sleepOrStress"
              checked={slotBookingData?.sleepOrStress}
              onChange={handleCheckboxChange}
            />
            {slotBookingData?.sleepOrStress && (
              <>
                <div className="d-flex flex-row gap-3 mb-n2">
                  <Form.Check
                    inline
                    type="radio"
                    id="improved"
                    label="Improved"
                    value="improved"
                    checked={
                      slotBookingData?.sleepOrStressStatus == "improved"
                        ? true
                        : false
                    }
                    required
                    name="sleepOrStressStatus"
                    onChange={handleCheckboxChange}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="notImproved"
                    label="Not Improved"
                    value="notImproved"
                    checked={
                      slotBookingData?.sleepOrStressStatus == "notImproved"
                        ? true
                        : false
                    }
                    required
                    name="sleepOrStressStatus"
                    onChange={handleCheckboxChange}
                  />
                </div>
                {slotBookingData?.sleepOrStressStatus === "improved" && (
                  <>
                    <p className="text-primary">
                      Emphasised on this being a small win and continue as per
                      product timeline
                    </p>
                    <p className="text-primary">
                      If 21 days of nasal drops over, explained the +ve impact
                      of nasal ghrit and suggested an optional longer use
                    </p>
                  </>
                )}
                {slotBookingData?.sleepOrStressStatus === "notImproved" && (
                  <>
                    If nasal already in kit
                    <p className="text-primary">
                      Probed on regularity of usage
                    </p>
                    <p className="text-primary">
                      Explained benefits of nasal and added nasal to kit for
                      another month
                    </p>
                    If nasal not in kit
                    <p className="text-primary">
                      Explained benefits of nasal and added to kit
                    </p>
                  </>
                )}
              </>
            )}
            <hr />
            <Form.Group controlId="reiteratedMonthlyGoals" className="mb-3">
              <Form.Check
                type="checkbox"
                label="Reiterated the monthly goals with customer"
                checked={slotBookingData?.reiteratedMonthlyGoals}
                id="reiteratedMonthlyGoals"
                name="reiteratedMonthlyGoals"
                onChange={handleCheckboxChange}
                className="mb-0"
              />
              {!slotBookingData?.reiteratedMonthlyGoals && (
                <Form.Text className="text-danger mt-0">
                  This field is mandatory
                </Form.Text>
              )}
            </Form.Group>
            <hr />
            <Form.Group controlId="regularUsage" className="mb-3">
              <Form.Label>Probed on whether regularly using the kit</Form.Label>
              <Form.Select
                value={slotBookingData?.regularUsage}
                onChange={handleCheckboxChange}
                name="regularUsage"
              >
                <option value="">Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
                <option value="partially">Partially</option>
              </Form.Select>
              {slotBookingData?.regularUsage === "" && (
                <Form.Text className="text-danger">
                  This field is mandatory
                </Form.Text>
              )}
            </Form.Group>
            <hr />
            <Form.Group controlId="newSupplementAdded" className="mb-3">
              <Form.Check
                type="checkbox"
                label="Has a new supplement been added?"
                checked={slotBookingData?.newSupplementAdded}
                onChange={handleCheckboxChange}
                name="newSupplementAdded"
              />
              {slotBookingData?.newSupplementAdded && (
                <Form.Group controlId="explanation" className="mb-3">
                  <Form.Label>Explain why</Form.Label>
                  <Form.Control
                    type="text"
                    value={slotBookingData?.explanation}
                    onChange={handleCheckboxChange}
                    name="explanation"
                  />
                  {slotBookingData?.explanation === "" && (
                    <Form.Text className="text-danger">
                      This field is mandatory
                    </Form.Text>
                  )}
                </Form.Group>
              )}
            </Form.Group>
            {/* <hr /> */}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
}

export default SubSection3;
